/* eslint-disable import/order */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";

// import { uploadFileToFirebase } from "../../utils/firebase_uploader";
import request from "../../utils/request";
import { updateUserManually } from "./authSlice";

// Initial state
const initialState = {
  isLoading: false,
  error: null,
  company: null,
  departments: [],
  roles: [],
};

// CREATE COMPANY
export const getMyCompany = createAsyncThunk(
  "company/getCompany",
  async (_, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/company/get`,
        method: "GET",
      });

      return response.data;
    } catch (error) {
      console.log("ERROR WHITE GETTING USER COMPANY", error);
      return rejectWithValue(error?.message);
    }
  }
);

// CREATE COMPANY
export const createCompany = createAsyncThunk(
  "company/createCompany",
  async ({ data, cb }, { dispatch, rejectWithValue }) => {
    try {
      console.log("CREATE COMPANY", data);

      const response = await request({
        url: `/company/create`,
        method: "POST",
        data: data,
      });
      console.log("CREATE COMPANY", data, response);

      if (typeof cb === "function") {
        cb(response);
      }

      enqueueSnackbar(response?.message, { variant: "success" });

      dispatch(updateUserManually({ company_id: response.data.id }));

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// UPDATE COMPANY
export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await request({
        url: `/company/update`,
        method: "PUT",
        data,
      });

      const { auth } = getState();
      const userInfo = auth.user?.personal_information;

      if (response?.message && response?.statusCode === 200) {
        enqueueSnackbar("Company updated successfully", { variant: "success" });
        dispatch(
          updateUserManually({
            company_id: response.data.id,
            personal_information: {
              ...userInfo,
              company_name: response?.data?.company_name,
            },
          })
        );
      }

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// GET DEPARTMENT COMPANY
export const getDepartments = createAsyncThunk(
  "departments/getDepartments",
  async (_, { rejectWithValue }) => {
    try {
      const response = await request({
        url: "/company/departments/get",
        method: "GET",
      });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for getting roles
export const getRoles = createAsyncThunk(
  "company/getRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/company/departments/get-roles`,
        method: "GET",
      });
      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Slice with extraReducers to handle state transitions
const slice = createSlice({
  name: "company",
  initialState,
  reducers: {
    resetCompany: () => initialState,

    updateCompanyManually: (state, action) => {
      state.company = { ...state.company, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyCompany.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMyCompany.fulfilled, (state, action) => {
        state.isLoading = false;
        state.company = action.payload || state.company;
      })
      .addCase(getMyCompany.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error || action.payload;
      })

      .addCase(getDepartments.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDepartments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.departments = action.payload || state.departments;
      })
      .addCase(getDepartments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error || action.payload;
      })
      .addCase(createCompany.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.isLoading = false;
        state.company = action.payload;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.company = null;
        state.isLoading = false;
        state.error = action.error || action.payload;
      })
      .addCase(updateCompany.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.isLoading = false;
        state.company = action.payload;
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.company = null;
        state.isLoading = false;
        state.error = action.error || action.payload;
      })
      .addCase(getRoles.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.roles = action.payload || [];
      })
      .addCase(getRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

// Exporting the reducer and resetCompany action
export const { resetCompany, updateCompanyManually } = slice.actions;

export const selectLoading = (state) => state.company.isLoading;
export const selectCompany = (state) => state.company.company;
export const selectDepartments = (state) => state.company.departments;

export const selectError = (state) => state.company.error;

export default slice.reducer;
